import React from 'react';

export const validateEmail = function (email) {
  return /.+@.+\..+/.test(email) && !/[ ,]/g.test(email);
};

export const hashcode = function (s) {
  let h = 0;
  const l = s.length;
  let i = 0;
  if (l > 0) {
    while (i < l) {
      h = ((h << 5) - h + s.charCodeAt(i++)) | 0;
    }
  }
  return h;
};

// encodes special characters e.g. < becomes &lt; so it's treated as a string and not parsed as html
export const HTMLToString = function (value) {
  const p = document.createElement('p');
  p.textContent = value;
  const s = p.innerHTML;
  return s;
};

// add wordbreaks to a string that has no white spaces (to enable it to wrap )
export function splitName(str) {
  if (!str) {
    return null;
  }
  const result = [];
  let span = '';
  for (let i = 0; i < str.length; i++) {
    if (str[i] === '_' || (str[i] >= 'A' && str[i] <= 'Z')) {
      if (span.length > 0) {
        result.push(<span key={`span${i}`}>{span}</span>);
        span = ''; // reset
      }
      result.push(<wbr key={`wbr${i}`} />);
    }
    span += str[i];
  }
  if (span.length > 0) {
    result.push(<span key="span-last">{span}</span>);
  }
  return <span>{result}</span>;
}

export function isLink(value) {
  // https://stackoverflow.com/questions/3809401/what-is-a-good-regular-expression-to-match-a-url
  return value.match(
    /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/gi,
  );
}
